import { CacheAxiosResponse } from "axios-cache-interceptor";

import { axios } from "../api";

import type { UserCompany } from "./user-management/types";

export function getUserCompanies(): Promise<
  CacheAxiosResponse<UserCompany[]>
> {
  return axios.get<UserCompany[]>("/v6/users/companies");
}
